<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  font-family: 'SYHTFont' !important;
}

@font-face {
  font-family: 'AlimamaShuHeiTi';
  src: url('../public/font/AlimamaShuHeiTi-Bold.ttf') format('woff2');
  font-weight: normal;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue